module.exports = __webpack_public_path__ + "908e4d2e/img/document.e2130c6b.svg";